import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useGlossarySectionHttp } from '@/core/api/glossary-sections'
import { GlossarySection, GlossarySectionPayload } from '@/core/models/glossary-section'

export type GlossarySectionCollection = {
    data: Array<GlossarySection>,
    meta?: MetaPayload,
    links?: any
}

const state: GlossarySectionCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const glossarySectionCollection: Module<GlossarySectionCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: GlossarySectionCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: GlossarySectionPayload) => {
                state.data.push(new GlossarySection(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useGlossarySectionHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: GlossarySectionCollection): GlossarySectionCollection => {
            return state
        }
    }
}